export default {
  toasts: {
    load_error: 'Laden van de tarieven mislukt',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  rates: {
    title: 'Verwerkingsmarge',
    description:
      'Percentage in %, plus een optioneel vast bedrag en minimumbedrag per betaling. „Elke betaalmethode” geldt wanneer er geen methodespecifiek tarief bestaat.',
  },
};
